<template>
  <m-integration-card
    :integration="slackIntegration"
    :loading="loading"
    lg
    sales
    tool="slack"
    @onConnect="connect"
    @onDisconnect="disconnect"
  >
  </m-integration-card>
</template>

<script lang="ts">
import Vue from 'vue';
import { TenantState } from '@/store/tenant';
import { IIntegration, IntegrationType } from '@mentessa/types';
import MIntegrationCard from '@/components/integrations/MIntegrationCard';
import { mapState } from 'vuex';

export default Vue.extend({
  name: 'm-tenant-integration-slack',
  components: {
    MIntegrationCard,
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    ...mapState<TenantState>('tenant', {
      integrations: (state: TenantState) => {
        return state.tenant.integrations;
      },
    }),
    slackIntegration() {
      return this.integrations.find((i: IIntegration) => i.type === IntegrationType.Slack);
    },
  },
  methods: {
    connect() {
      // ToDo: TBD
    },
    async disconnect() {
      // ToDo: TBD
    },
  },
});
</script>
